export default __webpack_public_path__ + "static/media/image-2.2361c824.webp";